module.exports = __webpack_public_path__ + "img/loading-bars.0af3a4f2.svg";